<div class="mt-4 max-h-[300px] overflow-y-auto">
  @for (record of sortedRecords; track record.id) {
    <aux-monthly-review-record [record]="record" />
  }
</div>
